import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

function LegalPage({ title, icon, sections }) {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="page-shell">
        <div className="page-inner">
          <button className="btn-secondary" style={{ marginBottom:20, width:'auto', padding:'8px 18px' }} onClick={() => navigate(-1)}>← Back</button>
          <div className="legal-card">
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:28 }}>
              <div style={{ width:48, height:48, background:'var(--gradient)', borderRadius:'var(--r-md)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>{icon}</div>
              <div>
                <h1 style={{ fontFamily:'DM Serif Display, serif', fontSize:26, letterSpacing:'-0.3px', marginBottom:3 }}>{title}</h1>
                <p style={{ fontSize:13, color:'var(--text-muted)' }}>Last updated: January 2026</p>
              </div>
            </div>
            {sections.map(([t,b]) => (
              <div className="legal-section" key={t}>
                <h3>{t}</h3>
                <p>{b}</p>
              </div>
            ))}
            <div className="legal-note">📧 Questions? Contact us at <strong>support@lendpesa.web.app</strong></div>
          </div>
        </div>
      </div>
    </>
  );
}

export function TermsPage() {
  return <LegalPage title="Terms & Conditions" icon="📜" sections={[
    ['1. Eligibility','Applicants must be Kenyan citizens aged 18 and above with a valid National ID and an active M-Pesa account. Lend Pesa reserves the right to approve or decline any application at its discretion.'],
    ['2. Loan Terms','All loans are offered on a 2-month repayment term at a flat interest rate of 10% per term. The processing fee is non-refundable once an STK push is initiated.'],
    ['3. Disbursement','Approved loans are disbursed to your M-Pesa within 24 hours of successful fee payment. We are not liable for delays caused by M-Pesa or network issues.'],
    ['4. Repayment','Borrowers must repay the full outstanding balance plus interest within the agreed term. Late payments may attract a 5% penalty of the outstanding amount per week.'],
    ['5. Data Use','Your personal information is used solely for loan processing and fraud prevention. We do not sell your data to third parties.'],
    ['6. Default','Failure to repay may result in legal action, reporting to credit bureaus, and restriction from future borrowing.'],
    ['7. Governing Law','These terms are governed by the laws of Kenya.'],
  ]} />;
}

export function PrivacyPage() {
  return <LegalPage title="Privacy Policy" icon="🔒" sections={[
    ['What We Collect','We collect your full name, email, phone number, National ID, and M-Pesa transaction history necessary for credit assessment.'],
    ['How We Use It','Your data is used to process your loan application, verify identity, prevent fraud, and communicate loan updates.'],
    ['Data Storage','All data is stored securely on Google Firebase with 256-bit encryption. We comply with Kenyan data protection laws.'],
    ['Who We Share With','We share data only with Payhero (M-Pesa payment processor). We do not sell, rent, or trade your personal information.'],
    ['Your Rights','You may request access to, correction of, or deletion of your personal data at any time by contacting us.'],
    ['Cookies','We use Firebase Authentication cookies to keep you logged in. No advertising cookies are used.'],
    ['Security','We use HTTPS, Firebase Authentication, and Firestore security rules to protect your data.'],
  ]} />;
}
